import React, { ElementType, forwardRef, FC } from 'react';
import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';

export interface NotificationCenterCategoryProps extends BoxProps<ElementType> {
  /**
   * Title of the notification
   */
  title: React.ReactNode;
  /**
   * Custom props for the header
   */
  headerProps?: BoxProps<ElementType>;
  /**
   * Custom props for the title
   */
  titleProps?: TypographyProps<ElementType>;
  /**
   * Custom props for the container
   */
  containerProps?: BoxProps<ElementType>;
}

/**
 * Component that renders a category in the Notification Center
 */
export const NotificationCenterCategory: FC<NotificationCenterCategoryProps> = forwardRef(
  ({ title, headerProps, titleProps, containerProps, children, ...rest }, ref) => {
    const { sx: titleSx, ...restTitle } = titleProps ?? {};

    return (
      <Box data-testid="NotificationCenterCategory" {...rest} ref={ref}>
        <Typography
          variant="caption2"
          sx={{
            pl: 1,
            pt: 2,
            pb: 1,
            display: 'block',
            borderBottom: 1,
            borderColor: 'surface.secondary',
            ...titleSx,
          }}
          data-testid="NotificationCenterCategory.title"
          {...restTitle}
        >
          {title}
        </Typography>
        <Box data-testid="NotificationCenterCategory.content" {...containerProps}>
          {children}
        </Box>
      </Box>
    );
  },
);
